import axios from "axios";

// Use the same backend as the local admin panel during development. Production
// builds continue to use the live API unless REACT_APP_API_URL is configured.
export const serverURL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === "production"
    ? "https://new.zaptodoor.com"
    : "https://new.zaptodoor.com"
);

// ================= TOKEN =================

const getToken = () => {
  return localStorage.getItem("Token") || "";
};

// ================= GET CONFIG =================

const getConfig = () => {
  const token = getToken();

  return {
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  };
};

// ================= GET =================

export const getData = async (url) => {
  try {
    const fullURL = `${serverURL}/${url}`;

    console.log("➡️ GET REQUEST:", fullURL);

    const config = getConfig();

    const response = await axios.get(fullURL, config);

    console.log("✅ GET RESPONSE:", response.data);

    return response.data;
  } catch (e) {
    console.error(
      "❌ GET ERROR:",
      e.response?.data || e.message
    );

    return {
      success: false,
      message:
        e.response?.data?.message ||
        e.message ||
        "GET request failed",
    };
  }
};

// ================= POST =================

export const postData = async (url, body = {}) => {
  try {
    const fullURL = `${serverURL}/${url}`;

    console.log("➡️ POST REQUEST:", fullURL);
    console.log("📤 POST BODY:", body);

    const token = getToken();

    const isFormData = body instanceof FormData;

    const config = {
      headers: {
        Authorization: token,

        ...(isFormData
          ? {}
          : {
              "Content-Type": "application/json",
            }),
      },
    };

    const response = await axios.post(
      fullURL,
      body,
      config
    );

    console.log("✅ POST RESPONSE:", response.data);

    return response.data;
  } catch (e) {
    console.error(
      "❌ POST ERROR:",
      e.response?.data || e.message
    );

    return {
      success: false,
      message:
        e.response?.data?.message ||
        e.message ||
        "POST request failed",
    };
  }
};

// ================= PUT =================

export const putData = async (url, body = {}) => {
  try {
    const fullURL = `${serverURL}/${url}`;

    console.log("➡️ PUT REQUEST:", fullURL);
    console.log("📤 PUT BODY:", body);

    const config = getConfig();

    const response = await axios.put(
      fullURL,
      body,
      config
    );

    console.log("✅ PUT RESPONSE:", response.data);

    return response.data;
  } catch (e) {
    console.error(
      "❌ PUT ERROR:",
      e.response?.data || e.message
    );

    return {
      success: false,
      message:
        e.response?.data?.message ||
        e.message ||
        "PUT request failed",
    };
  }
};

// ================= DELETE =================

export const deleteData = async (url) => {
  try {
    const fullURL = `${serverURL}/${url}`;

    console.log("➡️ DELETE REQUEST:", fullURL);

    const config = getConfig();

    const response = await axios.delete(
      fullURL,
      config
    );

    console.log("✅ DELETE RESPONSE:", response.data);

    return response.data;
  } catch (e) {
    console.error(
      "❌ DELETE ERROR:",
      e.response?.data || e.message
    );

    return {
      success: false,
      message:
        e.response?.data?.message ||
        e.message ||
        "DELETE request failed",
    };
  }
};

// ================= FILE UPLOAD =================

export const uploadFile = async (
  url,
  formData,
  onProgress = null
) => {
  try {
    const fullURL = `${serverURL}/${url}`;

    console.log("➡️ UPLOAD REQUEST:", fullURL);

    const token = getToken();

    const response = await axios.post(
      fullURL,
      formData,
      {
        headers: {
          Authorization: token,


        },

        onUploadProgress: onProgress,
      }
    );

    console.log(
      "✅ UPLOAD RESPONSE:",
      response.data
    );

    return response.data;
  } catch (e) {
    console.error(
      "❌ UPLOAD ERROR:",
      e.response?.data || e.message
    );

    return {
      success: false,
      message:
        e.response?.data?.message ||
        e.message ||
        "Upload failed",
    };
  }
};

// ================= DATE =================

export const getDate = () => {
  const cd = new Date();

  return `${cd.getFullYear()}/${
    cd.getMonth() + 1
  }/${cd.getDate()}`;
};

// ================= TIME =================

export const getTime = () => {
  const cd = new Date();

  return `${cd.getHours()}:${cd.getMinutes()}:${cd.getSeconds()}`;
};
